module.exports = __webpack_public_path__ + "img/194.fixed_coffee_machine.b65fb286.svg";